export default __webpack_public_path__ + "static/media/van_ttc.2ef1ba8f.png";